module.exports = __webpack_public_path__ + "static/media/myFoto.74294149.png";